import { render, staticRenderFns } from "./basePolicy.vue?vue&type=template&id=45b2ed82&scoped=true"
import script from "./basePolicy.vue?vue&type=script&lang=js"
export * from "./basePolicy.vue?vue&type=script&lang=js"
import style0 from "./basePolicy.vue?vue&type=style&index=0&id=45b2ed82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b2ed82",
  null
  
)

export default component.exports